import { useMemo } from "react";
import { useSelector } from "react-redux";
import recordingConstants from "../../../shared/constants/recordingConstants";
import {
  getCPVRRecordingStatus,
  isCPVRRecordingRecorded,
  isCPVRRecordingInProgress,
} from "../../../shared/utils/recordingHelper";

const { RECORDING_PARAMS } = recordingConstants;

const useRecordingSidebar = (programContent, isRecordingPlayer) => {
  const recordingsList = useSelector(({ recording }) => recording.recordingsList);
  const recordingsToDisplay = useMemo(() => {
    if (programContent?.[0]?.metadata?.programSeriesId && isRecordingPlayer && recordingsList?.length > 0) {
      for (const recording of recordingsList) {
        if (recording.recordingType === RECORDING_PARAMS.EVENT && recording.containers?.length > 0) {
          return recording.containers.filter((container) => {
            const recordingStatus = getCPVRRecordingStatus({ eventRecordingItem: container });
            return (
              (isCPVRRecordingRecorded(recordingStatus) || isCPVRRecordingInProgress(recordingStatus)) &&
              container.metadata?.programSeriesId === programContent[0].metadata.programSeriesId
            );
          });
        }
      }
    }
  }, [programContent, recordingsList, isRecordingPlayer]);

  const sortedRecordings = useMemo(() => {
    if (isRecordingPlayer) {
      if (recordingsToDisplay?.length > 0) {
        return recordingsToDisplay.sort(
          (recA, recB) =>
            recA.metadata?.season - recB.metadata?.season || recA.metadata?.episodeId - recB.metadata?.episodeId
        );
      } else {
        return programContent;
      }
    }
  }, [recordingsToDisplay, programContent, isRecordingPlayer]);

  const upNextRecording = useMemo(() => {
    if (sortedRecordings?.length > 1) {
      const currentRecordingIndex = sortedRecordings.findIndex((rec) => rec.id === programContent?.[0]?.id);
      return sortedRecordings[currentRecordingIndex + 1];
    }
  }, [programContent, sortedRecordings]);

  return { recordingsToDisplay, sortedRecordings, upNextRecording };
};

export default useRecordingSidebar;
